import React from 'react'
import { Box } from '../../Shared/Base'
import ModalSimple from '../../Shared/ModalSimple'

const IconSecure = () => (
  <svg height={58} width={58} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M17,17v-5c0-3.85986,3.14014-7,7-7s7,3.14014,7,7v5h4v-5c0-6.06543-4.93457-11-11-11S13,5.93457,13,12v5H17z "
        fill="#B3B3B3"
      />
      <path
        d="M39,47H9c-1.10457,0-2-0.89543-2-2V19c0-1.10457,0.89543-2,2-2h30c1.10457,0,2,0.89543,2,2v26 C41,46.10457,40.10457,47,39,47z"
        fill="#EFD358"
      />
      <path
        d="M28,29c0-2.20917-1.79083-4-4-4c-2.20911,0-4,1.79083-4,4c0,1.47681,0.80945,2.75232,2,3.44519V39h4 v-6.55481C27.19061,31.75226,28,30.47681,28,29z"
        fill="#A58C21"
      />
    </g>
  </svg>
)

const ModalScam = ({ onClickModalClose }) => {
  return (
    <ModalSimple has_icon_close={false}>
      <Box textAlign="center">
        <IconSecure />
        <Box as="h2" className="fz-20" color="secondary" mt={10}>
          Protégéz-vous des arnaques à la location
        </Box>
        <Box as="ul" className="list check" mt={30} maxWidth={520} mx="auto" color="text">
          <li>
            <Box as="strong">Insérez un filigrane sur vos documents</Box> <br />
            Par exemple : “Réservé à la location d’appartement”
          </li>
          <li>
            <Box as="strong">Ne payez jamais d’acompte pour réserver un bien</Box> <br />
            Fuyez si on vous parle de de western union, neo surf, mandat cash...
          </li>
          <li>
            <Box as="strong">Demandez un justificatif de propriété au loueur</Box> <br />
            Assurez-vous qu’il est bien le propriétaire via la taxe d’habitation.
          </li>
          <li className="alone">
            Consultez{' '}
            <Box
              as="a"
              href="https://blog.jinka.fr/comment-eviter-les-arnaques-a-la-location/"
              target="_blank"
              rel="noopener noreferrer"
              className="tdu"
              color="secondary"
            >
              notre article
            </Box>{' '}
            sur les arnaques à la location.
          </li>
        </Box>
        <Box as="button" className="btn is-medium is-primary" mt={40} onClick={onClickModalClose}>
          J'ai compris
        </Box>
      </Box>
    </ModalSimple>
  )
}

export default ModalScam
